
import React from 'react';
import { Navigate } from 'react-router-dom';

const DirectorOrAdminRoute = ({ user, children }) => {
    if (!user || (user.role !== 'admin' && user.role !== 'director')) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default DirectorOrAdminRoute;
